// extracted by mini-css-extract-plugin
module.exports = {"draggable":"QuickSearchCards_draggable__w3mg0","row":"QuickSearchCards_row__gSCfr","container":"QuickSearchCards_container__nlTua"};